import { useState } from "react";
import { Page, Tabs, Box, Banner, Link, BlockStack } from "@shopify/polaris";
import { trackEvent } from "../lib/mixpanel";
import styles from "./AnalyticsPage.module.scss";
import classNames from "classnames";

// Define period options as a constant to avoid duplication
const PERIOD_OPTIONS = ["today", "yesterday", "last7days", "last30days"];

const tabs = [
  {
    id: PERIOD_OPTIONS[0],
    content: "Today",
    accessibilityLabel: "Today",
    panelID: "today-panel",
  },
  {
    id: PERIOD_OPTIONS[1],
    content: "Yesterday",
    accessibilityLabel: "Yesterday",
    panelID: "yesterday-panel",
  },
  {
    id: PERIOD_OPTIONS[2],
    content: "Last 7 Days",
    accessibilityLabel: "Last 7 days",
    panelID: "last7days-panel",
  },
  {
    id: PERIOD_OPTIONS[3],
    content: "Last 30 Days",
    accessibilityLabel: "Last 30 days",
    panelID: "last30days-panel",
  },
];

export function AnalyticsPage() {
  const [period, setPeriod] = useState(PERIOD_OPTIONS[0]);

  const handleTabChange = (selectedTabIndex: number) => {
    setPeriod(PERIOD_OPTIONS[selectedTabIndex]);
  };

  const selectedTabIndex = PERIOD_OPTIONS.indexOf(period);

  function onContactSupport() {
    trackEvent("Contact Support Clicked");
  }

  function onReviewClick() {
    trackEvent("Review App Clicked");
  }

  let message = encodeURIComponent(
    `Hi, I am facing issues in adding the widget on my store. Can you help me out?`
  );
  const link = `https://wa.me/+918076623211?text=${message}`;
  // FIXME: fix this link
  const reviewLink = "https://apps.shopify.com/age-verification-44";

  return (
    <div className={classNames(styles.page, "analytics-page")}>
      <Page
        title="Analytics"
        primaryAction={{
          primary: false,
          content: "Contact Support",
          onAction: onContactSupport,
          external: true,
          url: link,
        }}
      >
        {/* <AnalyticsChart /> */}

        <Tabs
          tabs={tabs}
          selected={selectedTabIndex}
          onSelect={handleTabChange}
        />

        {/* Review Request Banner */}
        <Box paddingBlockStart="500" paddingInline="0">
          <Banner title="Enjoying Plain Age Verification?" tone="info">
            <BlockStack gap="200">
              <Box>
                <p>
                  Hi there! I'm a solo developer who built this app with ❤️ to
                  help small businesses like yours. If this app has been helpful
                  for your store, your review would mean the world to me and
                  help other merchants discover it too.
                </p>
              </Box>
              <Link
                url={reviewLink}
                target="_blank"
                onClick={onReviewClick}
                monochrome
                removeUnderline
              >
                <Box>
                  <p style={{ fontWeight: "bold" }}>
                    Leave a review on the Shopify App Store →
                  </p>
                </Box>
              </Link>
            </BlockStack>
          </Banner>
        </Box>
      </Page>
    </div>
  );
}
